import { createContext } from 'react';
import { ISubcategoryByCustomerV2, ISubcategoryByRestaurantV2 } from 'types';

export type TSortBy = '' | 'SubcategoriesA-Z' | 'SubcategoriesZ-A';
export type TCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow =
	| null
	| 'toConfirmDeleteItem'
	| 'success'
	| 'error'
	| 'assignRestaurants'
	| 'errorUpdatingSubcategory';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedCategory: Nullable<string>;
	isHidden: boolean;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
}

export interface ISubcategoryState {
	needRefetchData: boolean;
	subcategoriesByCustomer: ISubcategoryByCustomerV2;
	subcategoriesByRestaurant: ISubcategoryByRestaurantV2;
	searchString: string;
	rememberMyChoice: boolean;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedCategory: Nullable<string>;
	isHidden: boolean;
	sortBy: TSortBy;
	countOfItems: TCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	IDForAssignRestaurants: string;
	isInitializedSelectCustomerModal: boolean;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const subcategoryInitialState: ISubcategoryState = {
	needRefetchData: false,
	subcategoriesByCustomer: { totalCount: 0, items: [] },
	subcategoriesByRestaurant: { totalCount: 0, items: [] },
	searchString: '',
	rememberMyChoice: true,
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedCategory: null,
	isHidden: false,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	IDForAssignRestaurants: '',
	isInitializedSelectCustomerModal: false,
	typeOfModalWindow: null,
};

export interface ISubcategoryContext extends ISubcategoryState {
	refetchData(value: boolean): void;
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	toggleRememberMyChoice(): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDCategory(value: Nullable<string>): void;
	toggleIsHidden(): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TSortBy): void;
	setCountOfItems(count: TCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	setIDForAssignRestaurants(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const SubcategoryContext = createContext<ISubcategoryContext>({
	refetchData: () => undefined,
	deleteSelectedItem: async () => undefined,
	changeSearchString: () => undefined,
	toggleRememberMyChoice: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDCategory: () => undefined,
	toggleIsHidden: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	setIDForAssignRestaurants: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...subcategoryInitialState,
});
